import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/feature',
    name: 'Feature',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Feature.vue'),
  },
  {
    path: '/querysite',
    name: 'Querysite',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Querysite.vue'),
  },
  {
    path: '/location',
    name: 'Location',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Location.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/News.vue'),
  },
  {
    path: '/operation',
    name: 'Operation',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Operation.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import(/* webpackChunkName: "about" */ '../views/Faq.vue'),
  },
  {
    path: '*',
    redirect: '/querysite',
  },
];

const router = new VueRouter({
  routes,
});

export default router;
